// Polls the backend for Strong-key "+ROI Trifecta Play" detections among the
// supplied (up-next) races. Returns a map keyed `${track}|${race}` -> play spec.
// Gated server-side by the Auto Tri Bet admin config (per-FS version + opt-in
// exposure); returns {} when the current user isn't exposed or none qualify.
import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useTriPlays(races, date) {
  const [plays, setPlays] = useState({});
  const sigRef = useRef("");
  const sig = JSON.stringify((races || []).map((r) => [r.track, r.race])) + "|" + date;

  useEffect(() => {
    sigRef.current = sig;
    const list = (races || []).filter((r) => r.track && r.race != null);
    if (!date || list.length === 0) { setPlays({}); return; }
    let cancelled = false;
    const payload = list.map((r) => ({ track: r.track, race: r.race }));
    const run = async () => {
      try {
        const r = await axios.post(`${API}/quickpick/tri-plays`, { date, races: payload }, { withCredentials: true });
        if (cancelled || sigRef.current !== sig) return;
        const map = {};
        (r.data?.plays || []).forEach((p) => { map[`${p.track}|${p.race}`] = p; });
        setPlays(map);
      } catch { if (!cancelled) setPlays({}); }
    };
    run();
    const id = setInterval(run, 30000);
    return () => { cancelled = true; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sig]);

  return plays;
}

// Whole-card scan for a date (live + final races). Returns { byKey, byTrack, plays }
// so +ROI Trifecta races can be flagged in the track/race selector and race view
// even after they leave Up Next. Server-cached (60s); honors admin opt-in exposure.
export function useTriPlaysDay(date) {
  const [data, setData] = useState({ byKey: {}, byTrack: {}, plays: [] });
  useEffect(() => {
    if (!date) { setData({ byKey: {}, byTrack: {}, plays: [] }); return; }
    let cancelled = false;
    const run = async () => {
      try {
        const r = await axios.get(`${API}/quickpick/tri-plays-day`, { params: { date }, withCredentials: true });
        if (cancelled) return;
        const byKey = {}, byTrack = {};
        (r.data?.plays || []).forEach((p) => {
          byKey[`${p.track}|${p.race}`] = p;
          (byTrack[p.track] = byTrack[p.track] || []).push(p);
        });
        setData({ byKey, byTrack, plays: r.data?.plays || [] });
      } catch { if (!cancelled) setData({ byKey: {}, byTrack: {}, plays: [] }); }
    };
    run();
    const id = setInterval(run, 60000);
    return () => { cancelled = true; clearInterval(id); };
  }, [date]);
  return data;
}
